export const USER_FLAGS_ROUTE_PATHS = {
  userFlags: '/fraud/user-flags',
};
